import { Heading } from '@utilitywarehouse/hearth-react';
import { clsx } from 'clsx';
import { ReactNode } from 'react';

import { useBreakpoints } from '@utils/useBreakpoints.ts';

import './styles.scss';

type SlideHeadingProps = {
  children: ReactNode;
  newlineOnWord?: boolean;
};

type SlideSubHeadingProps = {
  children: ReactNode;
};

export const SlideHeading = ({
  children,
  newlineOnWord,
}: SlideHeadingProps) => {
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;

  return (
    <Heading
      as="h1"
      size={isMobile ? 'xl' : '2xl'}
      className={clsx(
        'slideHeading',
        newlineOnWord ? 'slideHeading--newline-on-word' : undefined
      )}
    >
      {children}
    </Heading>
  );
};

export const SlideSubHeading = ({ children }: SlideSubHeadingProps) => (
  <Heading as="h2">{children}</Heading>
);
